var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1905 0.9H1.80952C1.31088 0.9 0.9 1.30038 0.9 1.79406V12.2421C0.9 12.736 1.31093 13.1359 1.80952 13.1359H7.57857V14.3045H6.16071C5.9395 14.3045 5.75714 14.4809 5.75714 14.7021C5.75714 14.9235 5.93946 15.1 6.16071 15.1H12.8563C13.0773 15.1 13.2599 14.9235 13.2599 14.7021C13.2599 14.4809 13.0772 14.3045 12.8563 14.3045H11.4214V13.1359H17.1905C17.6891 13.1359 18.1 12.7358 18.1 12.2421V1.79406C18.1 1.30038 17.6891 0.9 17.1905 0.9ZM1.80952 1.69555H17.1905C17.2467 1.69555 17.2929 1.74341 17.2929 1.79426V10.1672H1.70714V1.79426C1.70714 1.74328 1.75322 1.69555 1.80952 1.69555ZM10.6143 14.3046H8.38571V13.1361H10.6143V14.3046ZM17.1905 12.3406H11.3214H7.67857H1.80952C1.75322 12.3406 1.70714 12.2927 1.70714 12.2421V10.9625H17.2929V12.2421C17.2929 12.2927 17.2468 12.3406 17.1905 12.3406Z",
    fill: "url(#paint0_linear_102_34174)",
    stroke: "url(#paint1_linear_102_34174)",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_34174",
    x1: 9.5,
    y1: 1,
    x2: 9.5,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A78CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: " #15DFF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_102_34174",
    x1: 9.5,
    y1: 1,
    x2: 9.5,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2299F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortal);
export default __webpack_public_path__ + "static/media/portal.1ae9bbeaf2eaaad8f485cf23c348b9d0.svg";
export { ForwardRef as ReactComponent };